import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capture } from '@/lib/analytics';

/**
 * Fires a PostHog $pageview on every memory-router navigation. posthog-js
 * autocapture can't see route changes here (no URL/History writes), so we
 * capture them explicitly. Renders nothing.
 */
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    capture('$pageview', {
      $current_url: location.pathname + location.search,
    });
  }, [location.pathname, location.search]);

  return null;
}
